import { useMutation } from "react-query";
import http from "infra/http";

function useDeleteUnidade() {
  return useMutation(
    "/v1/unidades/unidadeId",
    (id: string) => http.delete(`/v1/unidades/${id}`),
    { retry: false }
  );
}

export default useDeleteUnidade;
